import {
	faCheck as fasCheck,
	faCircleCheck as fasCircleCheck,
	faCircleExclamation as fasCircleExclamation,
	faCircleQuestion as fasCircleQuestion,
	faGamepadModern as fasGamepadModern,
	faGift as fasGift,
	faHyphen as fasHyphen,
	faLink as fasLink,
	faSquareSmall as fasSquareSmall,
	faTriangleExclamation as fasTriangleExclamation,
	faXmark as fasXmark,
} from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "classnames";
import type { FC, ReactNode } from "react";
import { useContext } from "react";
import { ListContext } from "./ListContext";
import type { ListItemProps, ListItemStyle } from "./List.types";
import { EXCLUDED_LIST_ITEM_STYLES } from "./List";

const getIcon = (itemStyle: ListItemStyle): IconDefinition | null => {
	switch (itemStyle) {
		case "square":
			return fasSquareSmall;
		case "link":
			return fasLink;
		case "tick":
			return fasCheck;
		case "circle-tick":
			return fasCircleCheck;
		case "info-circle":
			return fasCircleExclamation;
		case "question-circle":
			return fasCircleQuestion;
		case "warning-triangle":
			return fasTriangleExclamation;
		case "dash":
			return fasHyphen;
		case "xmark":
			return fasXmark;
		case "gamepad-modern":
			return fasGamepadModern;
		case "gift":
			return fasGift;
		default:
			return null;
	}
};

const renderIcon = (itemStyle: ListItemStyle): ReactNode => {
	const icon = getIcon(itemStyle);
	if (!icon) {
		return null;
	}
	return <FontAwesomeIcon icon={icon} className="mr-2" />;
};

const ListItem: FC<ListItemProps> = ({ children, itemStyle: itemStyleProp, className }) => {
	const { itemStyle: mainItemStyle } = useContext(ListContext);
	const itemStyle = itemStyleProp ?? mainItemStyle;

	return (
		<li
			className={clsx(
				className,
				EXCLUDED_LIST_ITEM_STYLES.includes(mainItemStyle) &&
					!EXCLUDED_LIST_ITEM_STYLES.includes(itemStyle) &&
					"list-style-none",
			)}
		>
			{renderIcon(itemStyle)}
			{children}
		</li>
	);
};

export default ListItem;
